import React from 'react';
import PropTypes from 'prop-types';
import { COMPARISON_MODES } from '../../constants';

/**
 * Metric Compare Toggle Component
 * Allows switching between different comparison modes for metrics
 * @param {Object} props - Component props
 * @param {string} props.comparisonMode - Currently selected comparison mode
 * @param {Function} props.onComparisonModeChange - Comparison mode change handler
 * @param {string} [props.className] - Additional CSS classes
 */
const MetricCompareToggle = ({ 
  comparisonMode, 
  onComparisonModeChange, 
  className = '' 
}) => {
  const modes = [
    { value: COMPARISON_MODES.NONE, label: 'No Comparison' },
    { value: COMPARISON_MODES.PREVIOUS, label: 'vs Previous Period' },
    { value: COMPARISON_MODES.PERCENTAGE, label: 'Show Percentage Change' }
  ];

  return (
    <div className={`metric-compare-toggle ${className}`}>
      <label className="filter-label">Comparison Mode</label>
      <div className="mode-buttons">
        {modes.map(({ value, label }) => (
          <button
            key={value}
            className={`mode-button ${comparisonMode === value ? 'active' : ''}`}
            onClick={() => onComparisonModeChange(value)}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
};

MetricCompareToggle.propTypes = {
  comparisonMode: PropTypes.string.isRequired,
  onComparisonModeChange: PropTypes.func.isRequired,
  className: PropTypes.string
};

export default MetricCompareToggle;
